module.exports = __webpack_public_path__ + "static/img/summer_banner.2a32a713.jpg";